export default __webpack_public_path__ + "static/media/2.8e528d60.png";